module.exports = __webpack_public_path__ + "static/media/module_badge_wellness_and_care.e9bab35c.png";